interface TagProps {
  text: string;
}

export const Tag = ({ text }: TagProps) => {
  return <div className="text-sm text-gray-500 rounded-full px-3 py-1 inline-block border border-gray-200">{text}</div>;
};
